export default "__VITE_ASSET__BdHxa6kO__"